import React from 'react';
import './_headerpage.scss';

import BackgroundDefault from '../../../resources/images/qualle.jpg';
export default class PageHeader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        let {children, image, nobottom, headline} = this.props;

        return  (
            <header className={"page--header" + (nobottom?" no-bottom-margin":"")}
                    style={{backgroundImage: 'url(' + image + ')'}}
                    >
                <div className="container-custom">
                    <h1 className={"headline massive featured header-contained"}>
                        {(headline?headline:children)}
                    </h1>
                </div>
            </header>
        )
    }
}

PageHeader.defaultProps = {
  image: BackgroundDefault
};



// WEBPACK FOOTER //
// ./src/components/header/page/index.jsx